<script lang="ts">
    import Icon from "./Icon.svelte";

    export let backButton = false;
    export let icon: "arrow-repeat" | "chevron-double-right" =
        "chevron-double-right";

    let submit: HTMLButtonElement;

    export const click = () => {
        submit.click();
    };

    function back() {
        history.back();
    }
</script>

<div class="text-end mt-3">
    {#if backButton}
        <button type="button" on:click={back} class="btn btn-secondary">
            <Icon icon="chevron-left" />
            Retour
        </button>
    {/if}
    <button bind:this={submit} type="submit" class="btn btn-primary">
        <slot />
        <Icon {icon} />
    </button>
</div>
